export default __webpack_public_path__ + "c285838a73d0372a922e3c77eb1afbec.svg";